<script>
import axios from 'axios';

class Address {

  constructor(authorization) {
    this.authorization = authorization;
    this.addressByIp = {};
    this.getAddressByIp()
      .finally();
  }

  getAddressByIp() {
    return new Promise((resolve) => {
      axios
        .get(
          '//suggestions.dadata.ru/suggestions/api/4_1/rs/detectAddressByIp',
          {
            headers: {
              Authorization: `Token ${this.authorization}`,
            },
          },
        )
        .then(({ data }) => {
          this.addressByIp = {};
          // eslint-disable-next-line no-restricted-syntax
          for (const prop in data.location.data) {
            // eslint-disable-next-line no-prototype-builtins
            if (data.location.data.hasOwnProperty(prop) && data.location.data[prop]) {
              this.addressByIp.data[prop] = data.location.data[prop];
            }
          }
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  getAddress(query) {
    return new Promise((resolve) => {
      axios
        .post(
          '//suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
          {
            count: 10,
            query,
            locations_boost: [
              this.addressByIp,
            ],
          },
          {
            headers: {
              Authorization: `Token ${this.authorization}`,
            },
          },
        )
        .then(({ data }) => {
          const items = (data.suggestions ? data.suggestions : [])
            .map(i => ({
              value: `${i.data.postal_code ? (`${i.data.postal_code}, `) : ''}${i.value}`,
              ...i,
            }));
          resolve(items);
        }, () => {
          resolve([]);
        });
    });
  }
}

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    authorization: {
      type: String,
      default: '6ccbcc2ffa7e52057d030e1bd69b1b5e4040e870',
    },
  },
  data() {
    return {
      el: null,
      address: new Address(this.authorization),
    };
  },
  methods: {
    async querySearch(query, cb) {
      cb(await this.address.getAddress(query || ''));
    },
  },
};
</script>
<template>
  <div>
    <div :class="{'is-disabled': disabled}">
      <el-autocomplete
              style="width: 100%;"
        :value="value"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        :fetch-suggestions="querySearch"
        :trigger-on-focus="false"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
      ></el-autocomplete>
    </div>
  </div>
</template>
<style lang="scss">

</style>
